/* eslint-disable */
// WARNING: DO NOT EDIT. This file is auto-generated by AWS Amplify.
// It will be overwritten. Stub for CI builds.

const awsmobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id:
    'us-east-2:placeholder-for-ci',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_placeholder',
  aws_user_pools_web_client_id: 'placeholder',
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
}

export default awsmobile
